module.exports = __webpack_public_path__ + "static/img/2.958e641.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/2.png
// module id = sg/g
// module chunks = 0